<mat-card>
    <mat-card-content class="newOrder gap-3" style="display: flex; flex-direction: column">
        <ng-container *ngIf="!requestError">
            <div class="newReqHead" id="top" fxFlex="100">
                <div class="viewRequestTitle">
                    <div class="vrTitle">
                        <title-back [addTitle]="viewDetails" [Title]="'Request No: '"
                                    (back)="closeView()"></title-back>
                        <span class="reqID">{{ requestService.selectedRequest?.request_number }}</span>
                    </div>
                    <div fxLayout="row wrap" class="chipset">
                        <ng-container [ngSwitch]="requestService.selectedRequest?.request_type?.dev_name">
                            <ng-container *ngSwitchCase="'buy_sell'">
                                <mat-chip class="secondary-chip sleek-chip">Trade</mat-chip>
                                <mat-chip
                                    class="secondary-chip sleek-chip">{{ requestService?.selectedRequest?.requestor?.company?.legal_name ?? requestService?.selectedRequest?.requestor?.company?.name }}
                                    {{ requestService.selectedRequest?.transaction_type == 'use' ? 'Buys ' : 'Sells ' }}
                                    &nbsp;
                                    <span
                                        *ngFor="let item of requestService?.selectedRequest?.requirement">{{ item?.quantity }}
                                        *{{ item?.container_size_type?.display }}
                                    </span>
                                </mat-chip>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <mat-chip class="secondary-chip sleek-chip">
                                    {{
                                        requestService.selectedRequest?.request_type?.dev_name == 'lease' ? 'Lease' :
                                            requestService.selectedRequest?.request_type?.dev_name == 'empty_repo' ? 'Empty Repo' :
                                                'One-Way'
                                    }}
                                </mat-chip>
                                <mat-chip class="secondary-chip sleek-chip">
                                    {{ requestService?.selectedRequest?.requestor?.company?.legal_name ?? requestService?.selectedRequest?.requestor?.company?.name }}
                                    {{ requestService.selectedRequest?.transaction_type == 'use' ? ' Uses ' : ' Supplies ' }}
                                    &nbsp;
                                    <span
                                        *ngFor="let item of requestService?.selectedRequest?.requirement | orderRequirements: 'container_size_type':'display':'asc'; let last = last">
                                {{ item?.quantity }}
                                        *{{ item?.container_size_type?.display }}{{ !last ? ',&nbsp;' : '' }}
                            </span>
                                </mat-chip>
                            </ng-container>
                            <!-- <mat-chip class="secondary-chip sleek-chip" *ngSwitchCase="'lease'">Lease</mat-chip> -->
                        </ng-container>
                        <mat-chip class="sleek-chip" style="color:white"
                                  [style.background-color]="requestService.selectedRequest?.status?.color">{{ requestService.selectedRequest?.status?.short_name }}
                        </mat-chip>
                        <mat-chip class="sleek-chip glider"
                                  *ngIf="requestService.selectedRequest?.requestor?.company?.is_virgin">New Lead
                        </mat-chip>
                    </div>

                </div>
                <!--        <div class="viewActions" fxLayout.gt-xs="row" fxLayout="column">-->
                <!--            <app-mat-auto-search [isEditable]="true" [displayField]="'request_number'" class="m1em countriesInput"-->
                <!--                                 [name]="'request_number'" [itemTemplate]="requestItem" fxLayout="column"-->
                <!--                                 placeholder="Search other request" [masterDashboard]="false" [ngModel]="request"-->
                <!--                                 (ngModelChange)="onRequestSelection($event)" [idField]="null"-->
                <!--                                 [listUrl]="request_url+'?search=::search::'"></app-mat-auto-search>-->

                <!--        </div>-->
            </div>

            <div class="contentFlex border-1px " fxFlex="100">
                <div *ngFor="let req of requestService?.selectedRequest?.requirement" class="detailsSlip">
                    <div class="polSlip">
                        <img src="assets/images/icons/ops_date_pol.svg">
                        <div class="polDetails">
                            <mat-chip [color]="'primary'" selected> {{
                                    req.quantity + ' x ' +
                                    req.container_size_type?.display
                                }}
                            </mat-chip>
                            <div class="locationList">
                                <span style="min-width: 34px"> POL - </span>
                                <span>
                                    <ng-container *ngFor="let pol of req.pol_list; let i = index">
                                        {{ pol?.display_name }}
                                        {{ (req.pol_list.length - 1) > i ? ' |' : '' }}
                                    </ng-container>
                                </span>
                            </div>
                        </div>
                    </div>
                    <mat-divider [vertical]="true"></mat-divider>
                    <div class="podSlip">
                        <img src="assets/images/icons/ops_date_pod.svg">
                        <div class="podDetails">
                            <mat-chip [color]="'primary'" selected>
                                {{ req.quantity + ' x ' + req.container_size_type?.display }}
                            </mat-chip>
                            <div class="locationList">
                                <span style="min-width: 35px">POD - </span>
                                <span>
                                    <ng-container *ngFor="let pod of req.pod_list;let i=index">
                                        {{ pod?.display_name }}
                                        {{ (req.pod_list.length - 1) > i ? ' |' : '' }}
                                    </ng-container>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row"
                 [ngClass]="dataSource?.data?.length != 0?'justify-content-between':'justify-content-end'"
                 class="  tableFilterNotation">
                <div *ngIf="dataSource?.data?.length != 0" class="opsDateChangeSearch">
                    <mat-form-field appearance="outline">
                        <input
                            matInput
                            class="p-b-0"
                            placeholder="Search ..."
                            matTooltip="Search by container number, pickup depot name, dropoff depot name, DO reference no, RR No"
                            (keyup)="applyFilter($event)"
                            [(ngModel)]="searchText"
                        />
                    </mat-form-field>
                </div>
                <div class="filter">
                    <div fxLayout="row" class="gap-2 justify-content-between w-100 align-items-center">
                        <span class="filter-label">Total Storage:</span>
                        <span [class.cutSpan]="storageTotal != storageTotalUpdated">{{ storageTotal }} {{
                                storageCurrency
                            }} </span>
                        <span *ngIf="storageTotal != storageTotalUpdated"
                              [ngClass]="storageTotal>storageTotalUpdated?'downwards':'upwards'">
                            {{ storageTotalUpdated }} {{ storageCurrency }}
                        </span>
                        <ng-container *ngIf="storageTotal != storageTotalUpdated">
                            <img *ngIf="storageTotal > storageTotalUpdated"
                                 matTooltip="- {{storageTotal-storageTotalUpdated}}"
                                 src="assets/images/icons/revenue_decrease.svg"
                                 alt="" width="22px">
                            <img *ngIf="storageTotal < storageTotalUpdated"
                                 matTooltip="+ {{storageTotalUpdated-storageTotal}}"
                                 src="assets/images/icons/revenue_increase.svg"
                                 alt="" width="22px">
                        </ng-container>
                    </div>
                    <div fxLayout="row" class="gap-2 justify-content-between w-100 align-items-center">
                        <span class="filter-label">Total Per Diem:</span>
                        <span
                            [class.cutSpan]="perDiemTotal != perDiemTotalUpdated">{{ perDiemTotal }} {{
                                perDiemCurrency
                            }} </span>
                        <span *ngIf="perDiemTotal != perDiemTotalUpdated"
                              [ngClass]="perDiemTotal>perDiemTotalUpdated?'downwards':'upwards'">
                         {{ perDiemTotalUpdated }} {{ perDiemCurrency }}
                     </span>
                        <ng-container *ngIf="perDiemTotal != perDiemTotalUpdated">
                            <img *ngIf="perDiemTotal > perDiemTotalUpdated"
                                 matTooltip="- {{perDiemTotal-perDiemTotalUpdated}}"
                                 src="assets/images/icons/revenue_decrease.svg"
                                 alt="" width="22px">
                            <img *ngIf="perDiemTotal < perDiemTotalUpdated"
                                 matTooltip="+ {{perDiemTotalUpdated-perDiemTotal}}"
                                 src="assets/images/icons/revenue_increase.svg"
                                 alt="" width="22px">
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="setTable" fxFlex="100">
                <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                           [class.fixedWidthColumn]="editAction==3">
                    <ng-container matColumnDef="container_number">
                        <mat-header-cell *matHeaderCellDef
                                         sortActionDescription="Container Number">
                            Container No
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="m-card-title" data-label="ContainerNo">
                            <div fxLayout="column">
                                <b>{{ element?.container?.container_number }}</b>
                                <div fxLayout="row wrap" class="gap-2 align-items-flex-start">
                                    <mat-chip
                                        class="secondary-chip sleek-chip">{{ element?.container?.container_size_type }}
                                    </mat-chip>
                                    <mat-chip class="secondary-chip sleek-chip">{{
                                            element?.container?.ownership + (element?.container?.ownership == 'Forwarding' ? '(' +
                                                element?.stock_owner?.name + ')' : '')
                                        }}
                                    </mat-chip>
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="pickup_date" *ngIf="editAction == 1 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Pick-up Date
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Pick-up Date">
                            <!--                                {{ element?.pickup_date | date : "dd MMM, yyyy" }}-->
                            <app-date-field [(ngModel)]="element.pickup_date"
                                            (dateChange)="updatePickupData(element)"
                                            [isEditable]="true" class="form-text"
                                            [name]="'pickup'" fxFlex="12.3em"
                                            [maxDate]="element?.dropoff_date"
                                            fxLayout="column">
                            </app-date-field>
                            <!-- [errors]="getErrorForContainer(element)"  -->
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="pickup_depot">
                        <mat-header-cell *matHeaderCellDef>
                            Pick-up Depot
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Pick-up Depot">
                            <div fxLayout="column" class="align-items-flex-start">
                                <span>{{ element?.pickup_depot?.display_name | titlecase }}</span>
                                <mat-chip>{{ element?.do_reference_no | titlecase }}</mat-chip>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dropoff_date" *ngIf="editAction == 2 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Drop-off Date
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Date">
                                <span *ngIf="element?.return_container_reference?.dropoff_date == null">
                                    {{
                                        element?.return_container_reference?.dropoff_date
                                            ? (element?.return_container_reference?.dropoff_date
                                                | date : "dd MMM, yyyy")
                                            : "-"
                                    }}
                                </span>
                            <app-date-field [(ngModel)]="element.return_container_reference.dropoff_date"
                                            *ngIf="element?.return_container_reference?.dropoff_date != null"
                                            (dateChange)="updateDropoffData(element)"
                                            [isEditable]="true" class="form-text"
                                            [minDate]="element?.pickup_date"
                                            [name]="'dropoff'" fxFlex="12.3em" fxLayout="column">
                            </app-date-field>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dropoff_depot" *ngIf="editAction == 2 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Drop-off Depot
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Depot">
                            <div fxLayout="column" class="align-items-flex-start">
                            <span>
                            {{
                                    element?.return_container_reference?.dropoff_depot?.display_name
                                        ? (element?.return_container_reference?.dropoff_depot
                                            ?.display_name | titlecase)
                                        : "-"
                                }}
                            </span>
                                <mat-chip>{{ element?.return_container_reference?.return_reference_no | titlecase }}</mat-chip>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="storage_charged_from" *ngIf="editAction == 1 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Storage Charged From
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Depot">
                            <div fxLayout="column" class="m-l-10">
                                <span>
                                    {{ element?.storage_charged_from | date: 'dd MMM, yyyy' }}
                                </span>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="free_days" *ngIf="editAction == 2 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Free Days
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Depot">
                            <div fxLayout="column" class="m-l-10">
                                <span>{{
                                        element?.free_days_min
                                    }}
                                    </span>
                                <!--                                <span>Max: {{-->
                                <!--                                        element?.free_days_max-->
                                <!--                                    }}-->
                                <!--                                    </span>-->
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="extra_storage_days" *ngIf="editAction == 1 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Stor. Days
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Depot">
                            <div fxLayout="column" class="m-l-10">
                                <span
                                    [class.cutSpan]="element?.extra_storage_days != element?.extra_storage_days_updated">{{
                                        element?.extra_storage_days
                                    }}
                                    </span>
                                <span
                                    [ngClass]="element?.extra_storage_days>element?.extra_storage_days_updated?'downwards':'upwards'"
                                    *ngIf="element?.extra_storage_days != element?.extra_storage_days_updated">{{
                                        element?.extra_storage_days_updated
                                    }}
                                    </span>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="extra_usage_days" *ngIf="editAction == 2 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Extra Usage Days
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Depot">
                            <div fxLayout="column" class="m-l-10">
                                <span [class.cutSpan]="element?.extra_usage_days != element?.extra_usage_days_updated">{{
                                        element?.extra_usage_days
                                    }}
                                    </span>
                                <span
                                    [ngClass]="element?.extra_usage_days>element?.extra_usage_days_updated?'downwards':'upwards'"
                                    *ngIf="element?.extra_usage_days != element?.extra_usage_days_updated">{{
                                        element?.extra_usage_days_updated
                                    }}
                                    </span>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="storage_charge" *ngIf="editAction == 1 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Storage Charge
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Depot">
                            <div fxLayout="column" class="m-l-10">
                                <span [class.cutSpan]="element?.storage_charge != element?.storage_charge_updated ">{{
                                        element?.storage_charge
                                    }} {{ element?.storage_charge_currency }}
                                </span>
                                <span
                                    [ngClass]="element?.storage_charge>element?.storage_charge_updated?'downwards':'upwards'"
                                    *ngIf="element?.storage_charge != element?.storage_charge_updated">{{
                                        element?.storage_charge_updated
                                    }} {{ element?.storage_charge_currency }}
                                    </span>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="per_diem" *ngIf="editAction == 2 || editAction == 3">
                        <mat-header-cell *matHeaderCellDef>
                            Per Diems
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="has_label_on_mobile"
                                  data-label="Drop-off Depot">
                            <div fxLayout="column" class="m-l-10">
                                <span
                                    [class.cutSpan]="element?.per_diem != element?.per_diem_updated">
                                    {{ element?.per_diem }} {{ element?.per_diem_currency }}
                                </span>
                                <span *ngIf="element?.per_diem != element?.per_diem_updated"
                                      [ngClass]="element?.per_diem>element?.per_diem_updated?'downwards':'upwards'"
                                      (mouseenter)="(element?.per_diem <= element?.per_diem_updated) ?
                                      showDetails(element) : ''" (mouseleave)="cancelSubscription()"
                                      style="cursor: pointer">{{
                                        element?.per_diem_updated
                                    }} {{ element?.per_diem_currency }}
                                    <div id="{{element?.id}}" *ngIf="rowId == element?.id">
                                        <div class="chargeDetails">
                                            <span *ngIf="rType == 'one_way'">
                                                {{ firstSlab }}
                                                {{ secondSlab != undefined ? secondSlab : '' }}
                                            </span>
                                            <span *ngIf="rType == 'lease'">
                                                {{ firstSlab }}
                                            </span>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
                <ng-container *ngIf="billuLoader ">
                    <logzy-billu [part1]="part1 " [part2]="part2 " [part3]="part3" font="14px"></logzy-billu>
                </ng-container>
                <div class="loadingData" [class.d-none]="!update">
                    <logzy-gear-loader></logzy-gear-loader>

                </div>
                <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons
                               aria-label="Select page">
                </mat-paginator>
            </div>
            <div class="input">
                <div class="field">
                    <span>Remark*</span>
                    <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="remarks"
                                    [name]="'remarks'">
                    </app-text-field>
                </div>
            </div>
            <div fxFlex="50" style="text-align: end; margin: 10px;">
                <button class="loadingBtn sleekBtn Save" mat-raised-button
                        [disabled]="disableSaveButton && dataSource.data.length == 0" (click)="save()">
                    <span *ngIf="!disableSaveButton">Save</span>
                    <div *ngIf="disableSaveButton" class="p03">
                        <i class="flaticon-loading spin"></i>
                        <span>Saving...</span>
                    </div>
                </button>
            </div>

        </ng-container>
        <ng-container *ngIf="requestError">
            <div>This request does not exist or you do not have permission to view this request..!!</div>
        </ng-container>
    </mat-card-content>
</mat-card>

<ng-template #requestItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="requestListShow">
            <span class="requestNumber">
                {{ item?.request_number }}
                <span> ({{ item.request_type.name }} | {{
                        item?.request_type?.dev_name == 'buy_sell' ?
                            item?.transaction_type == 'use' ? 'Buy' : 'Sell' : item?.transaction_type == 'use' ? 'Use' : 'Supply'
                    }}
                    {{ item?.requirement[0]?.quantity }}*{{ item?.requirement[0]?.container_size_type?.display }})
                    <ng-container *ngIf="item?.requirement.length>1">+ {{ item?.requirement.length - 1 }}
                        More</ng-container>
                </span>
            </span>
        <span class="companyName">
                {{ item?.company ?? '-' }}
            </span>
    </div>
</ng-template>
